export const ver = [
  '512 512',
  `
  <title>Visualizar</title>
  <g id="Capa_x0020_1">
    <g id="_693778808">
    <g>
      <path fill="#d8dbe0" d="M256,160.691A87.309,87.309,0,1,0,343.309,248,87.31,87.31,0,0,0,256,160.691ZM276,268H236V228h40Z"></path>
      <path fill="#d8dbe0" d="M397.222,130.864l-.218-.222c-77.75-77.749-204.258-77.749-282.008,0L16,233.554v28.892l98.778,102.69.218.222a199.637,199.637,0,0,0,282.008,0l99-102.912V233.554ZM343.193,335.193A123.311,123.311,0,1,1,379.309,248,122.5,122.5,0,0,1,343.193,335.193Z"></path>
    </g>
    </g>
  </g>
  `,
]
